import { render, staticRenderFns } from "./ProductionOrders.vue?vue&type=template&id=28bef26a&scoped=true"
import script from "./ProductionOrders.vue?vue&type=script&lang=js"
export * from "./ProductionOrders.vue?vue&type=script&lang=js"
import style0 from "./ProductionOrders.vue?vue&type=style&index=0&id=28bef26a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bef26a",
  null
  
)

export default component.exports